import {h, Fragment} from "preact"
import Product from './Product'
import { useAppStateSelector } from '@nosto/preact'
import { useEffect } from 'preact/hooks'

export default function Products() {
    const { products, loading } = useAppStateSelector((state) => ({
        products: state.response.products,
        loading: state.loading,
    }))

    useEffect(() => {
        Nosto.migrateToShopifyMarket({
            productSectionElement: '.ns-serp .nosto-product-info',
            productUrlElement: '.ns-serp .nosto-product-url',
            productHandleAttribute: 'x-nosto-handle',
            priceElement: '.ns-serp .nosto-price',
            listPriceElement: '.ns-serp .nosto-list-price',
        })
    }, [products])

    return (
        <product-list
            id="product-list-template--25089175781725__main"
            class="product-list"
            collection-mobile-layout="large"
            collection-desktop-layout="large">
            {products.hits.map((hit, index) => {
                return <Product product={hit} key={hit.productId || index} />
            })}
        </product-list>
    )
}
